import KpiIcon from './KpiIcon';

export default KpiIcon;
